import { getServiceUrl as p } from "../../compass/compass-services.js";
function w(o, u = "") {
  return async (r, e) => {
    const { CommonRequest: t } = await import("@3ds/common-request-proxification"), { Preferences: a } = await import("@3ds/common-preferences");
    if (t.checkHasProxyPath(r.url))
      return;
    const n = new Request(await p(o) || u).url;
    if (r.url.startsWith(n))
      return a.isNativeApp() ? await t.request(
        r.url,
        { ...e, proxy: "passport" },
        r
      ) : void 0;
    const s = new URL(r.url), i = `${n}${s.pathname}${s.search}`.replace(/([^:]\/)\/+/g, "$1"), c = new Request(i, e);
    return a.isNativeApp() ? await t.request(
      i,
      { ...e, proxy: "passport" },
      c
    ) : c;
  };
}
export {
  w as serviceProxy
};
